import React, { useMemo } from 'react';
import { Line } from '@ant-design/plots';
import { FormattedMessage } from 'react-intl';

// Цвет линии — $pc-accent-600 из токенов проекта. Проверен валидатором палитры на светлой
// подложке: попадает в допустимую полосу светлоты, проходит порог насыщенности и контраст ≥3:1.
const LINE_COLOR = '#648CE6';
const AXIS_INK = '#667085';   // $pc-gray-500 — оси и подписи текстовым цветом, а не цветом серии

const formatDate = (value) => new Date(value).toLocaleString('ru', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

const RatingChart = ({ history = [], selected = null, isLoading = false }) => {
  // История приходит от новых к старым, в стор кладётся уже развёрнутой; здесь только
  // разворачиваем JSON-срез метрик в плоские точки для графика.
  const data = useMemo(() => history.map((point) => {
    const metrics = typeof point.data === 'string' ? JSON.parse(point.data) : (point.data || {});

    return {
      date: formatDate(point.createdAt),
      score: Number(metrics.score) || 0,
    };
  }), [history]);

  const renderBody = () => {
    if (isLoading) {
      return <div className="rating-chart__empty"><FormattedMessage id="rating.chart.loading" defaultMessage="Loading…" /></div>;
    }

    if (data.length === 0) {
      return <div className="rating-chart__empty"><FormattedMessage id="rating.chart.noHistory" defaultMessage="No history for this request yet" /></div>;
    }

    // Одна точка линией не рисуется — показываем значение числом, иначе выглядит как пустой график.
    if (data.length === 1) {
      return (
        <div className="rating-chart__single">
          <strong>{data[0].score}</strong>
          <span>{data[0].date} — <FormattedMessage id="rating.chart.singlePoint" defaultMessage="history accumulates one point per day" /></span>
        </div>
      );
    }

    return (
      <Line
        data={data}
        xField="date"
        yField="score"
        height={260}
        autoFit
        scale={{ y: { nice: true } }}
        style={{ stroke: LINE_COLOR, lineWidth: 2 }}
        point={{
          sizeField: 4,
          style: { fill: LINE_COLOR, stroke: '#FFFFFF', lineWidth: 2 },
        }}
        axis={{
          x: { title: false, labelFill: AXIS_INK, labelFontSize: 11 },
          y: { title: false, labelFill: AXIS_INK, labelFontSize: 11 },
        }}
        tooltip={{ items: [{ channel: 'y', name: 'Quality' }] }}
      />
    );
  };

  return (
    <div className="rating-chart">
      {/* Заголовок называет серию — легенда для одной серии не нужна и только съедала бы место */}
      <div className="rating-chart__header">
        <span className="rating-chart__title"><FormattedMessage id="rating.chart.qualityHistory" defaultMessage="Quality history" /></span>
        {selected && (
          <span className="rating-chart__subtitle">
            {selected.keyword} · {selected.contentType}
          </span>
        )}
      </div>
      {renderBody()}
    </div>
  );
};

export default RatingChart;
